import { useState } from "react";
import { Button, Card, Space, Typography } from "antd";
import {
  KeyOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import PasswordForm from "nav/pages/user/profile/PasswordForm";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Text } = Typography;

const Settings = () => {
  const [activePanel, setActivePanel] = useState("");

  return (
    <div className="project-page dealer-settings-page">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3 flex-wrap">
        <WidgetSectionTitle
          icon={<SettingOutlined />}
          title="Settings"
          subtitle="Manage account security for your dealership"
          className="flex-1"
          titleStyle={{ color: OLIVEEB_COLORS.oliveebDarkGreen }}
          subtitleStyle={{ color: OLIVEEB_COLORS.oliveebGreen }}
        />
      </div>

      <Card
        style={{
          maxWidth: 720,
          borderRadius: 8,
          borderColor: OLIVEEB_COLORS.oliveebBlueSoft,
        }}
      >
        {activePanel === "password" ? (
          <PasswordForm onBack={() => setActivePanel("")} />
        ) : (
          <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Space align="start" size={14}>
              <span
                style={{
                  display: "inline-grid",
                  placeItems: "center",
                  width: 42,
                  height: 42,
                  borderRadius: 8,
                  background: OLIVEEB_COLORS.oliveebBlueSoft,
                  color: OLIVEEB_COLORS.oliveebBlue,
                }}
              >
                <SafetyCertificateOutlined />
              </span>
              <div>
                <Text strong style={{ color: OLIVEEB_COLORS.oliveebDarkGreen, fontSize: 16 }}>
                  Account security
                </Text>
                <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
                  Update the password used to sign in to this account.
                </Text>
              </div>
            </Space>

            <Button
              type="primary"
              icon={<KeyOutlined />}
              onClick={() => setActivePanel("password")}
              style={{
                background: OLIVEEB_COLORS.oliveebBlue,
                borderColor: OLIVEEB_COLORS.oliveebBlue,
                borderRadius: 8,
                fontWeight: 800,
              }}
            >
              Change password
            </Button>
          </Space>
        )}
      </Card>
    </div>
  );
};

export default Settings;
